import { gql } from '@apollo/client';
import {
  ILibraryCategoryEntertainment,
  LibraryCategoryEntertainmentFragment,
} from './libraryCategoryEntertainment';
import {
  ILibrarySocialMediaLinks,
  LibrarySocialMediaLinksFragment,
} from './librarySocialMediaLinks';
import { IMeetingPlaceSeoDescription } from '@/interfaces/meetingPlaceSeoDescription';

export interface ILibraryBrandEntertainment {
  id: string;
  name: string;
  slug: string;
  description: any;
  logo: any;
  coverImage: any;
  primaryCategory: ILibraryCategoryEntertainment;
  secondaryCategories: ILibraryCategoryEntertainment[];
  socialMediaLinks: ILibrarySocialMediaLinks;
  seoDescription: IMeetingPlaceSeoDescription;
}

export const LibraryBrandEntertainmentFragment = gql`
  ${LibraryCategoryEntertainmentFragment}
  ${LibrarySocialMediaLinksFragment}
  fragment LibraryBrandEntertainment on LibraryBrandEntertainment {
    name
    slug
    sys {
      id
    }
    description {
      json
    }
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryEntertainment
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryEntertainment
      }
    }
    socialMediaLinks {
      ...LibrarySocialMediaLinks
    }
    seoDescription
  }
`;

export const LibraryBrandEntertainmentMinifiedFragment = gql`
  ${LibraryCategoryEntertainmentFragment}
  fragment LibraryBrandEntertainmentMinified on LibraryBrandEntertainment {
    sys {
      id
      locale
    }
    name
    slug
    logo {
      description
      url
      height
      width
    }
    coverImage {
      description
      url
      height
      width
    }
    primaryCategory {
      ...LibraryCategoryEntertainment
    }
    secondaryCategoriesCollection(limit: 10) {
      items {
        ...LibraryCategoryEntertainment
      }
    }
  }
`;
